import { EmployeeJobLevelEnum } from 'common/constants/enum';
import { Translate } from 'next-translate';

const jobLevelOptions = (t: Translate) => [
  {
    id: EmployeeJobLevelEnum.Spv,
    label: t('enum:spv'),
  },
  {
    id: EmployeeJobLevelEnum.NonSales,
    label: t('enum:non-sales'),
  },
  {
    id: EmployeeJobLevelEnum.Sales,
    label: t('enum:sales'),
  },
  {
    id: EmployeeJobLevelEnum.Manager,
    label: t('enum:manager'),
  },
  {
    id: EmployeeJobLevelEnum.Director,
    label: t('enum:director'),
  },
];

export default jobLevelOptions;
